// Originate from https://github.com/catawiki/cw-buyer/blob/master/app/assets/client/types/collection.ts
import * as t from 'io-ts';

const CollectionPortraitImage = t.interface({
  orientation: t.literal('portrait'),
  url: t.string,
});
export type CollectionPortraitImage = t.TypeOf<typeof CollectionPortraitImage>;

const CollectionLandscapeImage = t.interface({
  orientation: t.literal('landscape'),
  url: t.string,
});
export type CollectionLandscapeImage = t.TypeOf<
  typeof CollectionLandscapeImage
>;

export const CollectionInfo = t.interface({
  id: t.number,
  title: t.string,
  description: t.union([t.null, t.string]),
  start_date: t.string,
  end_date: t.union([t.null, t.string]),
  hero_image: t.union([t.null, t.string]),
  categories: t.array(t.number),
  url: t.string,
  color: t.union([t.null, t.string]),
  title_color: t.union([t.null, t.string]),
  cta_text: t.union([t.null, t.string]),
  campaign_dates: t.union([t.null, t.string]),
  images: t.tuple([
    CollectionPortraitImage,
    CollectionPortraitImage,
    CollectionPortraitImage,
    CollectionLandscapeImage,
    CollectionLandscapeImage,
  ]),
  lot_count: t.number,
  tags: t.union([t.string, t.null]),
});
export type CollectionInfo = t.TypeOf<typeof CollectionInfo>;

export const CollectionInfoResponse = t.interface({
  collection: CollectionInfo,
});
export type CollectionInfoResponse = t.TypeOf<typeof CollectionInfoResponse>;
